(function () {
  'use strict';

  var VAR_NAME = '--oddit-app-bar-height';
  var MAX_BAR_HEIGHT = 240;
  var TOP_TOLERANCE = 4;
  var MIN_WIDTH_RATIO = 0.6;
  var MAX_DEPTH = 3;
  var MIN_OVERLAY_Z_INDEX = 1000;

  var EXCLUDED = [
    '.oddit-header-section',
    '.oddit-header',
    '.oddit-cart-drawer',
    '.oddit-search-drawer',
    '.oddit-header__mobile-menu',
    '.shopify-section-group-header-group',
    '.skip-to-content-link',
    '.shopify-pc__banner',
    '#MainContent',
    '#preview-bar-iframe',
    '#admin-bar-iframe',
    '#shopify-block-alia',
    '[data-marker-io]'
  ].join(',');

  var SKIP_TAGS = {
    SCRIPT: true,
    STYLE: true,
    NOSCRIPT: true,
    LINK: true,
    TEMPLATE: true,
    META: true
  };

  var root = document.documentElement;
  var lastValue = -1;
  var frame = null;
  var barObserver = null;
  var watchedBars = [];

  function getOverrideSelector() {
    var value = window.OdditAppBarSelector;
    if (typeof value !== 'string') return null;
    value = value.trim();
    return value ? value : null;
  }

  function isRendered(el, style) {
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;

    if (style.position === 'fixed' || style.position === 'sticky') {
      return parseFloat(style.opacity || '1') > 0.01;
    }

    return true;
  }

  function isOverlaying(style) {
    if (style.position === 'fixed' || style.position === 'sticky') return true;
    if (style.position === 'static') return false;

    var zIndex = parseInt(style.zIndex, 10);
    return !isNaN(zIndex) && zIndex >= MIN_OVERLAY_Z_INDEX;
  }

  function collectShallow(node, depth, out) {
    if (!node || depth > MAX_DEPTH) return;

    var children = node.children;
    if (!children) return;

    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (SKIP_TAGS[el.tagName]) continue;
      if (el.matches && el.matches(EXCLUDED)) continue;
      out.push(el);
      collectShallow(el, depth + 1, out);
    }
  }

  function getCandidates() {
    var override = getOverrideSelector();

    if (override) {
      try {
        return Array.prototype.slice.call(document.querySelectorAll(override));
      } catch (e) {
        return [];
      }
    }

    var out = [];
    collectShallow(document.body, 1, out);
    return out;
  }

  function measure() {
    if (!document.body) return { height: 0, bars: [] };

    var candidates = getCandidates();
    var viewportWidth = window.innerWidth || root.clientWidth || 0;
    var bottom = 0;
    var bars = [];

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var style = window.getComputedStyle(el);

      if (!isOverlaying(style)) continue;
      if (!isRendered(el, style)) continue;

      var rect = el.getBoundingClientRect();

      if (rect.height < 1 || rect.height > MAX_BAR_HEIGHT) continue;
      if (rect.width < viewportWidth * MIN_WIDTH_RATIO) continue;
      if (rect.top > TOP_TOLERANCE || rect.bottom <= 0) continue;

      if (rect.bottom > bottom) bottom = rect.bottom;
      bars.push(el);
    }

    return { height: Math.max(0, Math.round(bottom)), bars: bars };
  }

  function watchBars(bars) {
    if (!window.ResizeObserver) return;

    if (bars.length === watchedBars.length) {
      var same = true;
      for (var i = 0; i < bars.length; i++) {
        if (bars[i] !== watchedBars[i]) {
          same = false;
          break;
        }
      }
      if (same) return;
    }

    if (!barObserver) barObserver = new ResizeObserver(schedule);
    barObserver.disconnect();
    watchedBars = bars.slice();

    for (var j = 0; j < watchedBars.length; j++) {
      barObserver.observe(watchedBars[j]);
    }
  }

  function apply() {
    frame = null;

    var result = measure();

    if (result.height !== lastValue) {
      lastValue = result.height;
      root.style.setProperty(VAR_NAME, result.height + 'px');
    }

    watchBars(result.bars);
  }

  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(apply);
  }

  function init() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }

    root.style.setProperty(VAR_NAME, '0px');
    schedule();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });
    document.addEventListener('shopify:section:load', schedule);

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true });
    }

    var delays = [250, 750, 1500, 3000, 6000];
    for (var i = 0; i < delays.length; i++) {
      window.setTimeout(schedule, delays[i]);
    }
  }

  window.OdditAppBarOffset = {
    refresh: schedule,
    getHeight: function () {
      return lastValue < 0 ? 0 : lastValue;
    }
  };

  init();
})();
